export default "__VITE_ASSET__be717a28__"